import { BulkActionTargets } from '@shared/types/bulk-action-targets.type';
import {
  ManageCegTableRow,
  ManageCegTableSelectionState
} from '../types/manage-ceg-page.types';

export class ManageCegTableHelpers {
  public static getBulkTargetsFromSelection(selection: ManageCegTableSelectionState): BulkActionTargets {
    return {
      goals: Array.from(selection.goals),
      campaigns: Array.from(selection.campaigns),
      expGroups: Array.from(selection.expGroups),
    };
  }

  public static getInitials(fullName: string): string {
    const names: string[] = fullName.split(" ");
    const initials: string = names
      .map((name: string) => name.charAt(0).toUpperCase())
      .join('');
    return initials;
  }

  public static getChildRecordIds(target: ManageCegTableRow, includeTarget = false): string[] {
    const result: string[] = [];

    if (includeTarget) {
      result.push(target.id);
    }
    target.loadedChildren.forEach(child => {
      result.push(child.id);
      if (child.loadedChildren?.length) {
        result.push(...ManageCegTableHelpers.getChildRecordIds(child));
      }
    });

    return result;
  }
}
